class ArticleToc extends HTMLElement {
  connectedCallback() {
    this.tocNav = this.querySelector('[data-toc-nav]');
    this.contentEl = this.querySelector('[data-article-content]');

    if (!this.tocNav || !this.contentEl) return;

    this.headings = [...this.contentEl.querySelectorAll('h2')];
    if (!this.headings.length) return;

    this.buildToc();
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  buildToc() {
    for (const heading of this.headings) {
      if (!heading.id) {
        heading.id = this.slugify(heading.textContent);
      }

      const link = document.createElement('a');
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent.trim();
      link.className = 'article-zen__toc-item';
      link.addEventListener('click', (event) => {
        event.preventDefault();
        heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });

      this.tocNav.appendChild(link);
    }
  }

  handleScroll() {
    if (this.scrollRaf) cancelAnimationFrame(this.scrollRaf);
    this.scrollRaf = requestAnimationFrame(() => {
      const scrollY = window.scrollY + 140;
      let activeIndex = 0;

      for (let i = 0; i < this.headings.length; i++) {
        if (this.headings[i].offsetTop <= scrollY) {
          activeIndex = i;
        }
      }

      const links = this.tocNav.querySelectorAll('.article-zen__toc-item');
      for (const link of links) {
        link.classList.remove('article-zen__toc-item--active');
      }
      links[activeIndex]?.classList.add('article-zen__toc-item--active');
    });
  }

  slugify(text) {
    return text
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-');
  }
}

if (!customElements.get('article-toc')) {
  customElements.define('article-toc', ArticleToc);
}
